import { Pill } from '../../../layout/Pill.jsx';

export const STATUS_LABELS = {
  pending: 'بانتظار الموافقة',
  active: 'مفعّلة',
  suspended: 'موقوفة',
  rejected: 'مرفوضة'
};

const VARIANTS = {
  pending: 'warning',
  active: 'success',
  suspended: 'danger',
  rejected: 'muted'
};

export function StatusPill({ status }) {
  return <Pill variant={VARIANTS[status] || 'muted'}>{STATUS_LABELS[status] || status || '—'}</Pill>;
}
